export const squidUrl = 'https://squid.subsquid.io/apolloswap-squid/v/v1/graphql'
